import * as React from "react";
import { useEffect, createRef, useState, useLayoutEffect } from 'react';
const EmptySpace = (props: { extraOffset: number }) => {

    const inputRef = createRef<HTMLDivElement>();

    const [height, setHeight] = useState(10);
    const [footerHeight, setFooterHeight] = useState(0);

    const recalcHeight = () => {

        const newHeight = window.innerHeight - footerHeight - inputRef.current.offsetTop - (props.extraOffset ? props.extraOffset : 0);

        if (newHeight != height)
            setHeight(newHeight);
    }

    useEffect(() => {

        if (inputRef.current) {

            //recalcHeight();

            console.log('offset ', inputRef.current.offsetTop);

            const footerEl = document.getElementById("footer");
            if (footerEl) {
                console.log('footerEl.clientHeight ', footerEl.clientHeight);
                setFooterHeight(footerEl.clientHeight);
                recalcHeight();
            }
        }

        window.addEventListener('resize', recalcHeight);

    }, []);

    useLayoutEffect(() => {
        recalcHeight();
    });

    return (
        <div className="empty-space" ref={inputRef} style={{ height: height }}>

        </div>
    )
}

export default EmptySpace;